import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import { Iconfont } from "../../../../../../components/icon/iconfont";

const VipFaqItem = props =>{
    const { faq } = props;
    const [showContent, setShowContent] = useState();

    return <li className={cls.VipFaqItem}>
        <div className={cls.Title} onClick={()=>setShowContent(state=>!state)}>
            <Iconfont className={`${cls.JTIcon} ${showContent?cls.Active:""}`}>&#xe70d;</Iconfont>
            <span className={cls.Font}>{faq.question}</span>
        </div>
        {
            showContent && <div className={cls.Content}>
                <span>{faq.answer}</span>
            </div>
        }
    </li>
}

export default props =>{
    useStyles(cls);
    const { vipData } = props;

    const faqs = useMemo(() =>{
        return vipData?.faqs;
    }, [vipData])

    return <div className={cls.VipFaq}>
        <div className={cls.FaqHd}>
            <div className={cls.FaqDivide}></div>
            <div className={cls.FaqTitle}><FormattedMessage id="faqs" defaultMessage="FAQS" /></div>
            <div className={cls.FaqDivide}></div>
        </div>

        <ul>
            {
                faqs?.map((faq, index)=>(
                    <VipFaqItem key={faq+index} faq={faq} />
                ))
            }
        </ul>
    </div>
}